/**
 * Warning marker — appears before the avatar on an interviewer chip
 * whose Google/Outlook calendar isn't connected. On hover, shows the
 * same short tooltip copy as legacy KInterviewScheduler so recruiters
 * understand why that user's busy events won't render on the calendar.
 */
import { Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { PiCalendarXDuotone, PiSmileySadDuotone } from 'react-icons/pi';

interface InterviewerCalNotConnectedProps {
  size?: number;
}

// Default matches the chip's globe / set-timezone icon (`Globe05 size={16}`
// in InterviewerTimezoneTrigger). The previous 14 was visually mismatched
// when both icons appeared together on the same chip (sch-31 UI nit).
export function InterviewerCalNotConnected({
  size = 16,
}: InterviewerCalNotConnectedProps) {
  return (
    <Tooltip
      placement="top"
      bg="white"
      borderRadius="6px"
      boxShadow="0px 18px 18px rgba(215, 218, 235, 0.09), 0px 4px 10px rgba(215, 218, 235, 0.1)"
      label={
        <Flex align="center" gap="6px" p="8px">
          <Icon
            as={PiSmileySadDuotone as unknown as React.ElementType}
            w="18px"
            h="18px"
            color="secondary-700"
          />
          <Text fontSize="xs" color="secondary-900">
            Calendar not connected. Events not visible.
          </Text>
        </Flex>
      }
      shouldWrapChildren
    >
      <Icon
        as={PiCalendarXDuotone as unknown as React.ElementType}
        w={`${size}px`}
        h={`${size}px`}
        color="secondary-700"
        onClick={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
}
